import { render } from "./Advantage.html?vue&type=template&id=6675278c&ts=true&external"
import script from "./Advantage.vue?vue&type=script&lang=ts"
export * from "./Advantage.vue?vue&type=script&lang=ts"

import "./Advantage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__